import { useMemo } from 'react';

import { ProgressBarItem } from 'components/ProgressBar';
import { useApplyContext } from 'pages/Apply/context';

export interface ProgressSidebarHook {
  items: ProgressBarItem[];
  isLoading: boolean;
}

export default function useProgressSidebar(): ProgressSidebarHook {
  const { isLoading } = useApplyContext();
  const items: ProgressBarItem[] = useMemo(
    () => [
      {
        type: 'single',
        title: 'Review Quote',
        active: false,
      },
      {
        type: 'multi',
        title: 'Choose Payment',
        substeps: [
          {
            title: 'Choose Rate',
            active: false,
            type: 'single',
          },
          {
            title: 'Apply For Finance',
            active: true,
            type: 'single',
          },
          {
            title: 'Await Decision',
            active: false,
            type: 'single',
          },
          {
            title: 'Complete Purchase',
            active: false,
            type: 'single',
          },
        ],
      },
      {
        type: 'single',
        title: 'Complete',
        active: false,
      },
    ],
    [],
  );

  return {
    items,
    isLoading,
  };
}
